/* eslint-disable react/prop-types */
import ArrowForwardRoundedIcon from '@mui/icons-material/ArrowForwardRounded';
import { LoadingButton } from '../common';

/**
 * 下一步按钮
 * @param {Object} options
 * @param {String} options.text 文案
 * @param {Boolean} options.isLoading 是否 loading
 * @param {Boolean} options.disabled 是否 disabled
 * @param {Boolean} options.showIcon 是否展示 icon
 * @param {Function} options.onClick 点击事件
 */
export const ContinueButton = ({
  text = 'Continue',
  isLoading = false,
  disabled = false,
  showIcon = true,
  id = '',
  onClick,
}) => (
  <LoadingButton
    variant="outlined"
    disabled={disabled}
    loading={isLoading}
    endIcon={showIcon ? <ArrowForwardRoundedIcon /> : null}
    style={{
      borderRadius: '2px',
      color: '#ffffff',
      padding: '8px 16px',
      marginLeft: '20px',
      border: 'none',
    }}
    onClick={onClick}
    id={id}
  >
    {text}
  </LoadingButton>
);
